// extracted by mini-css-extract-plugin
module.exports = {"container":"QuestionGameChoose_container__2E5NU"};